import classNames from "classnames/bind";
import useId from "../behavior/useId";
import css from "./ReadMore.module.scss";

const cx = classNames.bind(css);

interface ReadMoreProps extends React.HTMLProps<HTMLParagraphElement> {
  children: React.ReactElement;
}

const ReadMore: React.FC<ReadMoreProps> = ({ children, ...rest }) => {
  const id = "read-more";
  return (
    <p {...rest}>
      <input
        key={id + "input"}
        id={id}
        type="checkbox"
        className={cx("more", "absolute h-0 w-0 opacity-0")}
      />
      <label
        key={id + "more"}
        className="text-blue-500 cursor-pointer hover:underline block text-right"
        htmlFor={id}
      >
        Read more ...
      </label>
      {children}
      <label
        key={id + "less"}
        className="text-blue-500 cursor-pointer hover:underline block text-right"
        htmlFor={id}
      >
        Read less ...
      </label>
    </p>
  );
};

export default ReadMore;
